import { useTranslation } from "react-i18next";
import { FailedIcon, DoneIcon, WarningIcon } from "../assets/registtyIcons/icons";

const RenderMatchStatus = ({
  value1,
  value2,
  matchText = "matchingStatus",
  spanStyle = "u-width--min-width_250",
  compareAsString = false,
}) => {
  const { t } = useTranslation("general");
  const status = matchStatus(value1, value2, compareAsString);
  const statusConfig = {
    exact: {
      icon: <DoneIcon width={20} height={20} />,
      textClass: "confirm-text",
      translationKey: "exact",
    },
    notExact: {
      icon: <WarningIcon width={20} height={20} />,
      textClass: "warning-text",
      translationKey: "notExact",
    },
    default: {
      icon: <FailedIcon width={20} height={20} />,
      textClass: "error-text",
      translationKey: "notExistent",
    },
  };
  const config = statusConfig[status] || statusConfig.default;
  return (
    <div className="o-column-row-switcher">
      <span className={`${spanStyle}`}>{t(matchText)}:</span>
      <div className="o-row o-row--gap-size_100 o-row--vertical-align_center">
        {config.icon}
        <span className={`t-body-text ${config.textClass}`}>
          {t(config.translationKey)}
        </span>
      </div>
    </div>
  );
};

const matchStatus = (value1, value2, compareAsString = false) => {
  // String comparison mode
  if (compareAsString) {
    const normalize = (str) => {
      if (!str || str === undefined || str === null) return null;
      return str.toString().trim().toLowerCase();
    };

    const normalized1 = normalize(value1);
    const normalized2 = normalize(value2);

    if (normalized1 === null || normalized1 === "") {
      return "notExistent";
    }

    if (normalized2 === null || normalized2 === "") {
      return "notExact";
    }

    return normalized1 === normalized2 ? "exact" : "notExact";
  }

  // Number comparison mode (existing code)
  const parseNumber = (value) => {
    if (value == null || value === undefined || value === "") return null;
    const str = value.toString().trim();
    const lastComma = str.lastIndexOf(",");
    const lastDot = str.lastIndexOf(".");
    let normalized;
    if (lastComma > lastDot) {
      normalized = str.replace(/\./g, "").replace(",", ".");
    } else {
      normalized = str.replace(/,/g, "");
    }
    const num = parseFloat(normalized);
    return isNaN(num) ? null : num;
  };

  const num1 = parseNumber(value1);
  const num2 = parseNumber(value2);

  if (num1 === null) {
    return "notExistent";
  }
  if (num2 === null) {
    return "notExact";
  }

  // Try multiple comparison strategies
  const tolerance = 0.0001; // Allow small differences for rounding
  // Strategy 1: Direct comparison (for already-scaled values like 480000 vs 4800)
  const directMatch = Math.abs(num1 - num2) < tolerance;
  // Strategy 2: value1 in thousands (e.g., 15.28 vs 15280)
  const scaledNum1 = num1 * 1000;
  const scaledMatch = Math.abs(scaledNum1 - num2) < tolerance;
  // Strategy 3: value2 in thousands (opposite case)
  const scaledNum2 = num2 * 1000;
  const reverseScaledMatch = Math.abs(num1 - scaledNum2) < tolerance;
  // Strategy 4: Ratio-based (handles the 480000 vs 4800 case = 100x)
  const ratio = num1 / num2;
  const ratioMatch = Math.abs(ratio - 100) < 0.001; // 100x ratio

  return directMatch || scaledMatch || reverseScaledMatch || ratioMatch
    ? "exact"
    : "notExact";
};

export default RenderMatchStatus;
